/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_LabelInputs */

const en_us2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions from your trainer`)
};

const pt_br2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas do personal`)
};

const es_419_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas de tu entrenador`)
};

const pt_pt2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas do treinador`)
};

const fr_fr2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions de ton coach`)
};

const de_de2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen von deinem Coach`)
};

const it_it2_coach_extra_ask_label = /** @type {(inputs: Coach_Extra_Ask_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande dal tuo coach`)
};

/**
* | output |
* | --- |
* | "Questions from your trainer" |
*
* @param {Coach_Extra_Ask_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_label = /** @type {((inputs?: Coach_Extra_Ask_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_label(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_label(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_label(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_label(inputs)
	return en_us2_coach_extra_ask_label(inputs)
});
export { coach_extra_ask_label as "coach-extra.ask_label" }